export default (number, sign = '', maximumFractionDigits = 2) => {

  const numberStyle = {
    style: 'currency',
    currency: 'USD'
  }

  number = parseFloat(number || 0)

  if (maximumFractionDigits > 2 || sign === '') {
    return number.toLocaleString('en-US', { maximumFractionDigits})
  }

  let formattedNum = number.toLocaleString('en-US', numberStyle)

  if (sign === '%') {
    formattedNum = `${formattedNum.replace('$', '')}%`
  }

  return formattedNum
}

